import 'swiper/less';
import 'swiper/less/navigation';
import 'swiper/less/pagination';
import 'swiper/less/zoom';
import { register } from 'swiper/element/bundle';
// overwrite Swiper styles
import './swiper.less';
register();
